import React, { memo, useEffect, useState } from "react";
import styles from "./index.module.less";
import { movie } from "@Api";
import Item from "./item";

interface IProps {
  title?: string;
  mainClass?: string;
  imgClass?: string;
  onEntries?: (data) => void;
  onClick?: (data) => void;
  request: any;
  params?: any;
  itemG4Class?: string;
}

const HotVideoList: React.FC<IProps> = ({
  title = "熱門影片",
  mainClass,
  imgClass,
  onEntries,
  onClick,
  request,
  params = {},
  itemG4Class = '',
}) => {
  const [list, setList] = useState<any>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const res = await request(params);
      // 旧版本API的res没有status
      res.data.hasOwnProperty("items") ? setList(res?.data?.items) : setList(res?.data);
    } catch (error) {}
  };

  if (list.length === 0) {
    return null;
  }
  return (
    <section className={styles["HotVideoList"]}>
      <h2>{title}</h2>
      <div id="VideoColList" className={`w-212 border-1 border-solid border-[#e8e8e8] p-14 pb-0 mb-40 ${mainClass}`}>
        {list.map((v, i) => (
          <Item
            data={v}
            itemG4Class={itemG4Class}
            key={i}
            type='hotVideo'
            imgClass={imgClass}
            onEntries={() => onEntries && onEntries(v)}
            onClick={() => onClick && onClick(v)}
          />
        ))}
      </div>
    </section>
  );
};

export default memo(HotVideoList);
